import { render, staticRenderFns } from "./FirstSubscription.vue?vue&type=template&id=1770037b&scoped=true&"
import script from "./FirstSubscription.vue?vue&type=script&lang=ts&"
export * from "./FirstSubscription.vue?vue&type=script&lang=ts&"
import style0 from "./FirstSubscription.vue?vue&type=style&index=0&id=1770037b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770037b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1770037b')) {
      api.createRecord('1770037b', component.options)
    } else {
      api.reload('1770037b', component.options)
    }
    module.hot.accept("./FirstSubscription.vue?vue&type=template&id=1770037b&scoped=true&", function () {
      api.rerender('1770037b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/FirstSubscription.vue"
export default component.exports